module.exports = {"TXTWCL_Continue":{"id":"TXTWCL_Continue","defaultMessage":"Fortsæt","track":"Continue"}}